/**
 * Starfield — ambient decorative particle layer for the Hub and Codex.
 *
 * Pure DOM so it layers naturally behind the overlay content without
 * competing with the Phaser scene's canvas budget. ~30 dots, randomized
 * once on mount; CSS handles the slow drift via `starfield-drift` keyframes
 * defined in dom-ui.css. Respects `prefers-reduced-motion` (drift stops,
 * dots remain as subtle depth cues).
 */
export class Starfield {
  private host: HTMLElement;
  private el: HTMLDivElement | null = null;

  constructor(host: HTMLElement, private readonly dotCount = 30) {
    this.host = host;
  }

  mount(): void {
    if (this.el) return;
    const field = document.createElement('div');
    field.className = 'starfield';
    field.setAttribute('aria-hidden', 'true');

    for (let i = 0; i < this.dotCount; i++) {
      const dot = document.createElement('span');
      dot.className = 'starfield__dot';
      dot.style.left = `${Math.random() * 100}%`;
      dot.style.top = `${Math.random() * 100}%`;
      dot.style.opacity = `${0.15 + Math.random() * 0.45}`;
      const scale = 0.6 + Math.random() * 1.4;
      dot.style.transform = `scale(${scale.toFixed(2)})`;
      field.appendChild(dot);
    }

    this.host.insertBefore(field, this.host.firstChild);
    this.el = field;
  }

  unmount(): void {
    this.el?.remove();
    this.el = null;
  }
}
